import React, { useState } from 'react';
import { useClient } from 'jsonapi-react';
import { TableCell, TableHead, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge, BadgeTruncate } from '@/components/ui/badge';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import { StudyGuideMatterDialog } from './study-guide-matter-dialog';

export function StudyGuideMatterRow(props) {
  const { matter } = props;

  const client = useClient();

  const [open, setOpen] = React.useState(false);
  const [isBlock, setIsBlock] = useState(matter.status === 'blocked');

  const taxonomyChildren = matter?.['taxonomy-children'] || [];

  const updateTaxonomyStatus = async (id, payload) => {
    try {
      const response = await client.mutate(`user_taxonomies/${id}`, payload);
    } catch (error) {
      console.error('Failed to update taxonomy:', error);
    }
  };

  const handleConfirm = () => {
    const newStatus = isBlock ? 'active' : 'blocked';
    updateTaxonomyStatus(matter.id, { status: newStatus });
    setIsBlock(!isBlock);
    setOpen(false);
  };

  return (
    <TableRow danger={isBlock}>
      <TableHead scope="row">
        <TableUser>
          <TableUserContent>
            <TableUserTitle>{matter?.['taxonomy-name']}</TableUserTitle>
          </TableUserContent>
        </TableUser>
      </TableHead>
      <TableCell>
        <BadgeTruncate
          items={taxonomyChildren}
          oneLine
        />
      </TableCell>
      <TableCell>
        {matter.isAdd && (
          <Badge
            variant="attention"
            size="xs"
            title={'Você adicionou'}
          >
            {'Você adicionou'}
          </Badge>
        )}
      </TableCell>
      <TableCell>
        {isBlock ? (
          <Button
            variant="outline-success"
            size="sm"
            fullWidth
            onClick={handleConfirm}
          >
            Desbloquear
          </Button>
        ) : (
          <Dialog
            open={open}
            onOpenChange={setOpen}
          >
            <DialogTrigger asChild>
              <Button
                variant="outline-danger"
                size="sm"
                fullWidth
              >
                Bloquear
              </Button>
            </DialogTrigger>

            <StudyGuideMatterDialog onSubmit={handleConfirm} />
          </Dialog>
        )}
      </TableCell>
    </TableRow>
  );
}
